<template>
	<div class="form__group">
		<TreeSelect
            v-model="selected"
            :multiple="multiple"
            :options="options"
            :searchable="true"
            :flat="true"
            :autoDeselectAncestors="false"
            :autoDeselectDescendants="true"
            :autoSelectAncestors="includeAncestors"
            :autoSelectDescendants="false"
            :flattenSearchResults="true"
            placeholder="Select..."
            :normalizer="normalizer"
            :valueFormat="valueFormat"
            :load-options="loadOptions"
        />
		<label class="form__label">{{ label }}</label>
		<div class="form__validation" slot="validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import TreeSelect from '@riophae/vue-treeselect';
	import Sectors from './../../../sectors';
    import API from '@api';

	export default {
		inject: {
			$validator: '$validator'
		},
		$_veeValidate: {
			value() {
				return this.selected;
			},
			name() {
				return this.name;
			},
		},
		name: 'FormControlSector',
		components: {
			TreeSelect
		},
		props: {
			value: {
				required: true,
			},
			name: {
				type: String,
				required: true,
			},
			label: {
				type: String,
				default: 'Sector',
			},
			multiple: {
				type: Boolean,
				default: false,
			},
			includeAncestors: {
				type: Boolean,
				default: true,
			},
            customSectors: {
              type: Array,
              default: () => []
            },
            valueFormat: {
                type: String,
                default: 'id',
            }
		},
		data() {
            console.log({ test: this.value })
			return {
				options: this.customSectors.length > 0 ? this.customSectors : Sectors,
				selected: this.value || null,
			}
		},
		methods: {
            async loadOptions({ action, parentNode, callback }) {
                if (action === 'LOAD_CHILDREN_OPTIONS') {
                    try {
                        console.log({parentNode})
                        parentNode.children = await API.getSubSectors(parentNode.id);
                        callback();
                    } catch(err){
                        callback(new Error('Failed to load options: network error.'));
                    }
                }
            },
			normalizer(node) {
				return {
					id: node.id,
					label: node.name,
					children: typeof node.children === "object" ? node.children : null,
					// isDefaultExpanded: false,
				}
			},
		},
        created: function() {
          this.options = this.customSectors.length > 0 ? this.customSectors : Sectors;
        },
		watch: {
            customSectors(newValue) {
                this.options = newValue.length > 0 ? newValue : Sectors;
            },
			value(value) {
                console.log({value});
				if(this.multiple && !this.selected.length && value.length){
					this.selected = value;
				} else {
					if(!this.selected) {
						this.selected = value;
					}
				}
			},
			selected(selected) {
				this.$emit('input', selected);
			},
		},
	}
</script>
